// Affordable Golf GTM and GA4 ecommerce data layer
// Refactored: 2026-07-15
console.log("=======================================");
console.log("Affordable Golf GTM and GA4 ecommerce data layer");
console.log("Version : 2026-07-15 18:38 BST");
console.log("Loaded  :", new Date().toISOString());
console.log("=======================================");

(function () {
    'use strict';

    var CONFIG = {
        gtmContainerId: 'GTM-T7L35X',
        affiliation: 'Online Store',
        debug: false,
        useSkuAsItemId: window.localStorage && window.localStorage.skuAsId === 'yes'
    };

    var state = {
        gtmLoaded: false,
        collectionLookupStarted: false,
        collectionProductsTracked: false,
        addToCartBound: false
    };

    window.dataLayer = window.dataLayer || [];

    function log() {
        if (!CONFIG.debug || !window.console) {
            return;
        }
        window.console.log.apply(window.console, arguments);
    }

    function getCurrency() {
        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
            return Shopify.currency.active;
        }
        if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) {
            return ShopifyAnalytics.meta.currency;
        }
        if (window.Shopify && Shopify.checkout && Shopify.checkout.currency) {
            return Shopify.checkout.currency;
        }
        return 'GBP';
    }

    function toNumber(value, fallback) {
        var number = parseFloat(value);
        return Number.isFinite(number) ? number : fallback || 0;
    }

    function moneyFromCents(value) {
        return toNumber(value, 0) / 100;
    }

    function getMetaPageType() {
        if (window.meta && meta.page && meta.page.pageType) {
            return meta.page.pageType;
        }
        if (window.location.pathname.indexOf('/cart') === 0) {
            return 'cart';
        }
        if (window.location.href.indexOf('thank_you') !== -1 || window.location.href.indexOf('/orders/') !== -1) {
            return 'purchase';
        }
        return 'other';
    }

    function isCheckoutConfirmationPage() {
        return window.location.href.indexOf('thank_you') !== -1 || window.location.href.indexOf('/orders/') !== -1;
    }

    function getVirtualPagePath() {
        if (window.location.href.indexOf('checkouts') !== -1 && window.meta && meta.page && meta.page.path) {
            return meta.page.path;
        }
        return window.location.pathname + window.location.search;
    }

    function safeJsonParse(value, fallback) {
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallback;
        }
    }

    function getProductJsonUrl() {
        return window.location.protocol + '//' + window.location.hostname + window.location.pathname + '.js' + window.location.search;
    }

    function fetchJson(url) {
        return window.fetch(url, { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) {
                throw new Error('Request failed: ' + response.status + ' ' + url);
            }
            return response.json();
        });
    }

    function getSelectedVariant(product) {
        if (!product || !product.variants || !product.variants.length) {
            return {};
        }

        var urlVariantId = new URLSearchParams(window.location.search).get('variant');
        var formVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
        var selectedVariantId = urlVariantId || (formVariantInput && formVariantInput.value);
        var selectedVariant = product.variants.filter(function (variant) {
            return String(variant.id) === String(selectedVariantId);
        })[0];

        return selectedVariant || product.variants[0];
    }

    function getQuantity(scope) {
        var root = scope || document;
        var quantityInput = root.querySelector('[name="quantity"], #quantity, #Quantity');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function storeVariantCategory(variantId, category) {
        if (!variantId || !category) {
            return;
        }
        sessionStorage.setItem('variantId' + String(variantId), category);
    }

    function getStoredVariantCategory(variantId) {
        return sessionStorage.getItem('variantId' + String(variantId)) || '';
    }

    function getItemId(source) {
        if (CONFIG.useSkuAsItemId && source && source.sku) {
            return String(source.sku);
        }
        return String(source && (source.product_id || source.productId || source.id || source.variant_id || source.variantId) || '');
    }

    function normalizeItem(source, options) {
        var opts = options || {};
        var product = opts.product || source || {};
        var variant = opts.variant || source || {};
        var price = opts.price;

        if (typeof price === 'undefined') {
            if (typeof source.price === 'number' && source.price > 999) {
                price = moneyFromCents(source.price);
            } else {
                price = toNumber(source.price || source.final_price || variant.price || product.price || product.price_min, 0);
            }
        }

        var item = {
            item_id: getItemId({
                id: product.id || source.product_id || source.id,
                product_id: source.product_id || product.id,
                sku: source.sku || variant.sku
            }),
            item_name: source.product_title || source.title || product.title || source.name || '',
            affiliation: CONFIG.affiliation,
            item_brand: source.vendor || product.vendor || '',
            item_category: opts.category || source.product_type || product.product_type || product.type || getStoredVariantCategory(source.variant_id || variant.id),
            item_variant: source.variant_title || variant.title || variant.name || '',
            price: toNumber(price, 0),
            quantity: toNumber(opts.quantity || source.quantity, 1),
            google_business_vertical: 'retail'
        };

        if (source.variant_id || variant.id) {
            item.item_variant_id = String(source.variant_id || variant.id);
        }
        if (source.sku || variant.sku) {
            item.item_sku = String(source.sku || variant.sku);
        }
        if (opts.index) {
            item.index = opts.index;
        }
        if (opts.itemListId) {
            item.item_list_id = opts.itemListId;
        }
        if (opts.itemListName) {
            item.item_list_name = opts.itemListName;
        }
        if (opts.coupon) {
            item.coupon = opts.coupon;
        }
        if (opts.discount) {
            item.discount = toNumber(opts.discount, 0);
        }

        return item;
    }

    function pushGa4Event(eventName, ecommerce, extra) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(Object.assign({
            event: eventName,
            ecommerce: ecommerce
        }, extra || {}));
        log('GA4 event pushed:', eventName, ecommerce);
    }

    function injectGtmSnippet() {
        if (state.gtmLoaded || !CONFIG.gtmContainerId) {
            return;
        }

        state.gtmLoaded = true;
        window.dataLayer.push({
            event: 'ag_gtm_loader',
            ag_gtm_version: '2026-07-15',
            page_path: getVirtualPagePath()
        });

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0];
            var j = d.createElement(s);
            var dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.setAttribute('data-cfasync', 'false');
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', CONFIG.gtmContainerId);

        document.addEventListener('DOMContentLoaded', function () {
            if (!document.body || document.getElementById('ag-gtm-noscript')) {
                return;
            }

            var noscript = document.createElement('noscript');
            noscript.id = 'ag-gtm-noscript';
            noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + CONFIG.gtmContainerId + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
            document.body.insertBefore(noscript, document.body.firstChild);
        });
    }

    function getOrderId() {
        if (window.Shopify && Shopify.checkout && Shopify.checkout.order_id) {
            return String(Shopify.checkout.order_id);
        }

        var orderNumber = document.querySelector('.os-order-number');
        if (orderNumber) {
            var match = orderNumber.textContent.match(/#?\d+/);
            if (match) {
                return match[0].charAt(0) === '#' ? match[0] : '#' + match[0];
            }
        }

        return 'Shopify-' + Date.now();
    }

    function getCheckoutCoupon() {
        if (!window.Shopify || !Shopify.checkout) {
            return '';
        }
        if (Shopify.checkout.discount && Shopify.checkout.discount.code) {
            return Shopify.checkout.discount.code;
        }
        if (Shopify.checkout.discount_applications && Shopify.checkout.discount_applications.length) {
            return Shopify.checkout.discount_applications.map(function (discount) {
                return discount.title || discount.code;
            }).filter(Boolean).join(',');
        }
        return '';
    }

    function buildCheckoutItems() {
        if (!window.Shopify || !Shopify.checkout || !Shopify.checkout.line_items) {
            return [];
        }

        var coupon = getCheckoutCoupon();
        return Shopify.checkout.line_items.map(function (lineItem, index) {
            var category = getStoredVariantCategory(lineItem.variant_id);
            return normalizeItem(lineItem, {
                index: index + 1,
                category: category,
                coupon: coupon,
                price: toNumber(lineItem.price, 0),
                quantity: lineItem.quantity
            });
        });
    }

    function trackPurchase() {
        if (!isCheckoutConfirmationPage() || !window.Shopify || !Shopify.checkout) {
            return;
        }

        var orderId = getOrderId();
        var storageKey = 'ag_ga4_purchase_' + orderId;
        if (sessionStorage.getItem(storageKey)) {
            return;
        }

        var checkout = Shopify.checkout;
        var taxOnTotal = window.localStorage && window.localStorage.taxontotal;
        var totalValue = taxOnTotal === 'notax' ? toNumber(checkout.subtotal_price, 0) : toNumber(checkout.total_price, 0);
        var shipping = checkout.shipping_rate ? toNumber(checkout.shipping_rate.price, 0) : 0;
        var coupon = getCheckoutCoupon();

        pushGa4Event('purchase', {
            transaction_id: orderId,
            affiliation: CONFIG.affiliation,
            value: totalValue,
            tax: toNumber(checkout.total_tax, 0),
            shipping: shipping,
            currency: getCurrency(),
            coupon: coupon,
            items: buildCheckoutItems()
        });

        sessionStorage.setItem(storageKey, '1');
    }

    function trackCheckoutStep() {
        if (!window.Shopify || !Shopify.Checkout || !Shopify.Checkout.step) {
            return;
        }

        var step = Shopify.Checkout.step;
        var items = safeJsonParse(sessionStorage.getItem('ag_ga4_cart_items'), buildCheckoutItems());
        var value = items.reduce(function (sum, item) {
            return sum + item.price * item.quantity;
        }, 0);
        var eventName = '';
        var ecommerce = {
            currency: getCurrency(),
            value: value,
            items: items
        };

        if (step === 'contact_information') {
            eventName = 'begin_checkout';
        } else if (step === 'shipping_method' || step === 'shipping') {
            eventName = 'add_shipping_info';
        } else if (step === 'payment_method' || step === 'payment') {
            eventName = 'add_payment_info';
        }

        if (eventName) {
            pushGa4Event(eventName, ecommerce, { checkout_step: step });
        }
    }

    function trackCollectionView(collectionHandle, collectionTitle) {
        if (!collectionHandle || state.collectionProductsTracked) {
            return;
        }

        state.collectionProductsTracked = true;
        fetchJson('/collections/' + encodeURIComponent(collectionHandle) + '/products.json')
            .then(function (data) {
                var products = data.products || [];
                var itemListName = collectionTitle || collectionHandle;
                var items = products.map(function (product, index) {
                    var variant = product.variants && product.variants[0] ? product.variants[0] : {};
                    storeVariantCategory(variant.id, product.product_type || product.type);
                    return normalizeItem(product, {
                        product: product,
                        variant: variant,
                        index: index + 1,
                        itemListId: collectionHandle,
                        itemListName: itemListName,
                        category: product.product_type || product.type,
                        price: toNumber(variant.price || product.price_min, 0),
                        quantity: 1
                    });
                });

                if (items.length) {
                    pushGa4Event('view_item_list', {
                        currency: getCurrency(),
                        item_list_id: collectionHandle,
                        item_list_name: itemListName,
                        items: items
                    });
                }
            })
            .catch(function (error) {
                log('Collection product tracking failed:', error);
            });
    }

    function getCollectionFromStorage(resourceId, handleFromUrl) {
        var collections = safeJsonParse(sessionStorage.getItem('ag_collections'), []);
        return collections.filter(function (collection) {
            return String(collection.id) === String(resourceId) || collection.handle === handleFromUrl;
        })[0];
    }

    function loadCollections(page, collections) {
        return fetchJson('/collections.json?limit=250&page=' + page).then(function (data) {
            var nextCollections = collections.concat(data.collections || []);
            if (data.collections && data.collections.length === 250) {
                return loadCollections(page + 1, nextCollections);
            }
            sessionStorage.setItem('ag_collections', JSON.stringify(nextCollections));
            return nextCollections;
        });
    }

    function initCollectionTracking() {
        var pageType = getMetaPageType();
        var handleFromUrl = new URLSearchParams(window.location.search).get('collection');
        var isCollectionContext = pageType === 'collection' || pageType === 'home' || Boolean(handleFromUrl);

        if (!isCollectionContext || state.collectionLookupStarted) {
            return;
        }

        state.collectionLookupStarted = true;

        var resourceId = window.meta && meta.page ? meta.page.resourceId : '';
        var storedCollection = getCollectionFromStorage(resourceId, handleFromUrl);
        if (storedCollection) {
            trackCollectionView(storedCollection.handle, storedCollection.title);
            return;
        }

        loadCollections(1, [])
            .then(function (collections) {
                var collection = collections.filter(function (item) {
                    return String(item.id) === String(resourceId) || item.handle === handleFromUrl;
                })[0] || collections[0];

                if (collection) {
                    trackCollectionView(collection.handle, collection.title);
                }
            })
            .catch(function (error) {
                log('Collection lookup failed:', error);
            });
    }

    function trackProductView() {
        if (getMetaPageType() !== 'product') {
            return;
        }

        fetchJson(getProductJsonUrl())
            .then(function (product) {
                var variant = getSelectedVariant(product);
                var price = moneyFromCents(variant.price || product.price_min || 0);
                storeVariantCategory(variant.id, product.type);

                pushGa4Event('view_item', {
                    currency: getCurrency(),
                    value: price,
                    items: [
                        normalizeItem(product, {
                            product: product,
                            variant: variant,
                            category: product.type,
                            price: price,
                            quantity: 1
                        })
                    ]
                }, {
                    product_image_url: product.featured_image || '',
                    compare_at_price: variant.compare_at_price || ''
                });
            })
            .catch(function (error) {
                log('Product view tracking failed:', error);
            });
    }

    function findAddToCartButton(target) {
        return target.closest([
            'button[name="add"]',
            'button[type="submit"]',
            '[id^="add-to-cart"]',
            '[id^="add"]',
            '[id^="AddToCart"]',
            '[id^="product-add"]',
            '[id^="shopify_add_to_cart"]',
            '[data-action="add-to-cart"]',
            '.add_to_cart',
            '.ProductForm__AddToCart',
            '.so-btn-add-to-cart'
        ].join(','));
    }

    function trackProductAddToCart(button) {
        fetchJson(getProductJsonUrl())
            .then(function (product) {
                var variant = getSelectedVariant(product);
                var quantity = getQuantity(button.closest('form') || document);
                var price = moneyFromCents(variant.price || product.price_min || 0);
                storeVariantCategory(variant.id, product.type);

                pushGa4Event('add_to_cart', {
                    currency: getCurrency(),
                    value: price * quantity,
                    items: [
                        normalizeItem(product, {
                            product: product,
                            variant: variant,
                            category: product.type,
                            price: price,
                            quantity: quantity
                        })
                    ]
                });
            })
            .catch(function (error) {
                log('Product add_to_cart tracking failed:', error);
            });
    }

    function trackCollectionAddToCart(button) {
        var productForm = button.closest('.product_form, form[action*="/cart/add"]') || document.querySelector('.product_form');
        if (!productForm || !productForm.dataset || !productForm.dataset.product) {
            return false;
        }

        var product = safeJsonParse(productForm.dataset.product, null);
        if (!product) {
            return false;
        }

        var variantSelect = productForm.querySelector('[name="id"]');
        var variantId = variantSelect && variantSelect.value;
        var variant = (product.variants || []).filter(function (item) {
            return String(item.id) === String(variantId);
        })[0] || product.variants && product.variants[0] || {};
        var quantity = getQuantity(productForm);
        var price = moneyFromCents(variant.price || product.price || 0);

        storeVariantCategory(variant.id, product.type || product.product_type);
        pushGa4Event('add_to_cart', {
            currency: getCurrency(),
            value: price * quantity,
            items: [
                normalizeItem(product, {
                    product: product,
                    variant: variant,
                    category: product.type || product.product_type,
                    price: price,
                    quantity: quantity
                })
            ]
        });

        return true;
    }

    function bindAddToCartTracking() {
        if (state.addToCartBound) {
            return;
        }

        state.addToCartBound = true;
        document.addEventListener('click', function (event) {
            var button = findAddToCartButton(event.target);
            if (!button) {
                return;
            }

            if (getMetaPageType() === 'product') {
                trackProductAddToCart(button);
                return;
            }

            trackCollectionAddToCart(button);
        });
    }

    function trackCartView() {
        if (window.location.pathname.indexOf('/cart') !== 0) {
            return;
        }

        fetchJson('/cart.js')
            .then(function (cart) {
                var items = (cart.items || []).map(function (lineItem, index) {
                    storeVariantCategory(lineItem.variant_id, lineItem.product_type);
                    return normalizeItem(lineItem, {
                        index: index + 1,
                        category: lineItem.product_type,
                        price: moneyFromCents(lineItem.price),
                        quantity: lineItem.quantity
                    });
                });

                sessionStorage.setItem('ag_ga4_cart_items', JSON.stringify(items));
                pushGa4Event('view_cart', {
                    currency: getCurrency(),
                    value: moneyFromCents(cart.total_price),
                    items: items
                });
            })
            .catch(function (error) {
                log('Cart view tracking failed:', error);
            });
    }

    function init() {
        injectGtmSnippet();
        trackPurchase();
        trackCheckoutStep();

        if (!isCheckoutConfirmationPage()) {
            initCollectionTracking();
            trackProductView();
            bindAddToCartTracking();
            trackCartView();
        }
    }

    init();
})();
